/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Check if current keyboardEvent is the 'Backspace' key
 *
 * @param {Object} keyboardEvent The keyboard event to check
 * @return {Boolean} Will return 'false' if it's a different keyboard key in the event
 */

export const isBackspace = (keyboardEvent) => {
  if(typeof keyboardEvent !== 'object') {
    throw new Error('key should be typeof object');
  }
  return keyboardEvent.key === 'Backspace';
};

